<template>
    <CChartDoughnut
            :datasets="defaultDatasets"
            :options="defaultOptions"
            :labels="defaultLabels"
            :plugins="plugins"

    />
</template>

<script>
    import { CChartDoughnut } from '@coreui/vue-chartjs'
    import { getStyle, hexToRgba } from '@coreui/utils/src'
    // import {Chart} from 'chart.js';
    import ChartDataLabels from 'chartjs-plugin-datalabels';

    export default {
        data(){
            return {
                plugins:[],
                chat_lable:ChartDataLabels,
            }

        },
        name: 'MainChartDoughnut',
        components: {
            CChartDoughnut
        },
        props:{
            chart_datas:Array,
            label: String,
            barColor:String


        },
        mounted() {

            this.plugins=[this.chat_lable]
            },
        computed: {
            defaultDatasets () {
                // const brandInfo = getStyle('info') || '#321fdb'

                const data1 = []
                const colors = []
                for (let i = 0; i <= this.chart_datas.length; i++) {
                    if(this.chart_datas[i]!= null){

                        data1.push(this.chart_datas[i].count)
                        colors.push(hexToRgba(this.chart_datas[i].color, 100))
                    }

                }

                return [
                    {
                        backgroundColor: colors,
                        pointHoverBackgroundColor: this.barColor,
                        borderWidth: 2,
                        data: data1
                    },

                ]
            },
            defaultLabels () {
                var labels = [];
                for (let i = 0; i <= this.chart_datas.length; i++) {
                    if(this.chart_datas[i]!= null) {

                        labels.push(this.chart_datas[i].label)
                    }
                }
                return labels;
            },
            defaultOptions () {
                return {
                    plugins: {
                        // Change options for ALL labels of THIS CHART
                        datalabels: {
                            color: '#36A2EB'
                        }
                    },
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    title: {
                        display: true,
                        text: this.label
                    },
                    showAllTooltips: true,

                    tooltips: {

                        callbacks: {
                            label(tooltipItem, data) {
                                return `${data.labels[tooltipItem.index]}: ${data.datasets[0].data[tooltipItem.index]}%`;
                            }
                        }
                    },
                    scales: {
                        xAxes: [{
                            display: false,

                            barPercentage: 0.4,
                            gridLines: {
                                drawOnChartArea: false
                            }
                        }],
                        yAxes: [{

                            ticks: {
                                beginAtZero: true,
                                maxTicksLimit: 5,
                                stepSize: Math.ceil(50 / 5),
                            },
                            gridLines: {
                                display: false
                            }
                        }]
                    },
                    elements: {
                        point: {
                            radius: 0,
                            hitRadius: 10,
                            hoverRadius: 4,
                            hoverBorderWidth: 3
                        }
                    }
                }
            }
        }
    }
</script>
